import {createFileRoute, redirect} from '@tanstack/react-router';

/** Legacy redirect: /profile/lists/:listId/edit → /dashboard/lists/:listId/edit. */
export const Route = createFileRoute('/profile/lists/$listId/edit')({
  beforeLoad: ({params}) => {
    throw redirect({
      to: '/dashboard/lists/$listId/edit',
      params: {listId: params.listId},
    });
  },
});
